import { render, staticRenderFns } from "./InfoSettings.vue?vue&type=template&id=acb1eec2&"
import script from "./InfoSettings.vue?vue&type=script&lang=js&"
export * from "./InfoSettings.vue?vue&type=script&lang=js&"
import style0 from "./InfoSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VDivider,VFlex,VIcon,VLayout})
